__turbopack_context__.v({
  "glow": "preloader-module-scss-module__fQh0ZG__glow",
  "inner": "preloader-module-scss-module__fQh0ZG__inner",
  "logoSvg": "preloader-module-scss-module__fQh0ZG__logoSvg",
  "logoWrapper": "preloader-module-scss-module__fQh0ZG__logoWrapper",
  "overlay": "preloader-module-scss-module__fQh0ZG__overlay",
  "preloaderGlowIntro": "preloader-module-scss-module__fQh0ZG__preloaderGlowIntro",
  "preloaderGlowPulse": "preloader-module-scss-module__fQh0ZG__preloaderGlowPulse",
  "preloaderLogoIdle": "preloader-module-scss-module__fQh0ZG__preloaderLogoIdle",
  "preloaderLogoIntro": "preloader-module-scss-module__fQh0ZG__preloaderLogoIntro",
  "preloaderRingIntro": "preloader-module-scss-module__fQh0ZG__preloaderRingIntro",
  "preloaderRingSpin": "preloader-module-scss-module__fQh0ZG__preloaderRingSpin",
  "preloaderScanline": "preloader-module-scss-module__fQh0ZG__preloaderScanline",
  "ring": "preloader-module-scss-module__fQh0ZG__ring",
  "scanline": "preloader-module-scss-module__fQh0ZG__scanline",
});
